import { Navigate, Route } from 'react-router';
import { MagicPage } from './activation/MagicPage';
import { DocumentsPage } from './documents/DocumentsPage';
import { PortalLayout } from './frame/PortalLayout';
import { LoginPage } from './login/LoginPage';
import { ObjectsPage } from './objects/ObjectsPage';
import { OverviewPage } from './overview/OverviewPage';
import { ProfilePage } from './profile/ProfilePage';
import { QuestionsPage } from './questions/QuestionsPage';

/**
 * The public client portal (PLAN §8.3, F2): outside the AppShell and the internal session. `/portal/m/:token` is the
 * magic link (Portal 02, 08–10), `/portal/:orgSlug/login` the login (11–13), `/portal/:orgSlug/*` the signed-in
 * portal (14–22).
 */
export const portalRoutes = (
  <>
    <Route path="/portal/m/:token" element={<MagicPage />} />
    <Route path="/portal/:orgSlug/login" element={<LoginPage />} />
    <Route path="/portal/:orgSlug" element={<PortalLayout />}>
      <Route index element={<OverviewPage />} />
      <Route path="objects" element={<ObjectsPage />} />
      <Route path="documents" element={<DocumentsPage />} />
      <Route path="profile" element={<ProfilePage />} />
      <Route path="questions" element={<QuestionsPage />} />
      <Route path="*" element={<Navigate to=".." replace />} />
    </Route>
  </>
);
